<div *ngIf="currentScreen === 'Login'" id="login-component" class="container-fluid h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="row h-100 g-0" [formGroup]="login_form">
        <!-- Login Form Column -->
        <div class="col-md-4 p-0 d-flex justify-content-center align-items-center">
            <div class="card mb-0">
                <div class="screen-card">
                    <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png"
                        style="width: 176px; margin-bottom: 20%" />
                    <div class="card-title text-left">Welcome</div>
                    <input type="text" style="display: none;" name="Mode" value="Login" />
                    <div class="form-group" style="width: 100%">
                        <mat-form-field appearance="outline" class="example-full-width mask" style="width: 100%">
                            <mat-label>Username</mat-label>
                            <input name="Username" formControlName="Username" autocomplete="off" type="text" matInput
                                placeholder="Username" />
                            <span class="text-danger"
                                *ngIf="login_form.controls['Username'].hasError('required') && (login_form.controls['Username'].dirty || login_form.controls['Username'].touched)">This
                                field is required</span>
                        </mat-form-field>
                    </div>
                    <div class="form-group" style="width: 100%">
                        <mat-form-field appearance="outline" class="example-full-width mask" style="width: 100%">
                            <mat-label>Password</mat-label>
                            <input name="Password" formControlName="Password" autocomplete="off"
                                [type]="showPassword ? 'text' : 'password'" matInput placeholder="Password" />
                            <mat-icon matSuffix (click)="togglePasswordVisibility()">{{
                                showPassword
                                ? 'visibility_off'
                                : 'visibility'
                                }}</mat-icon>
                            <span class="text-danger"
                                *ngIf="login_form.controls['Password'].hasError('required') && (login_form.controls['Password'].dirty || login_form.controls['Password'].touched)">Password
                                is required</span>
                        </mat-form-field>
                    </div>
                    <div class="input-bottom-section">
                        <div class="checkbox-div">
                            <input type="checkbox" name="RememberMe" />
                            <div class="checkbox-text">Remember me</div>
                        </div>
                        <div class="forgot-password-text">
                            <a href="/ForgotPassword.aspx">Forgot Password?</a>
                        </div>
                    </div>
                    <div class="login-div">
                        <button class="btn default-success rounded-pill" type="submit">
                            Login
                        </button>
                    </div>

                    <div *ngIf="message" class="alert alert-danger" role="alert" style="margin-top:50px">
                      {{message.text}}
                    </div>

                </div>
            </div>

            <div class="term-of-services">
                <div class="policy-text">
                    By clicking on “Login”, you are agreeing to our
                    <a href="/Terms.aspx">Terms of service</a> and <br />
                    acknowledge that our Privacy policy applies to you
                </div>
                <div class="version-text">
                    © {{year}} m-View Live Video Pty Ltd | Altitude version: {{version}}
                </div>
            </div>
        </div>
        <!-- Background Image Column -->
        <div class="col-md-8 position-relative">
            <p class="vision-text position-absolute">
                Get <span> vision</span> <br />
                where it matters
            </p>
        </div>
    </div>
</div>

<div *ngIf="currentScreen === 'MFACodeScreen'" id="mfa-qr-code-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay" [formGroup]="MFAForm">
        <div class="mfr-code-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="mfr-title">Multi-factor authentication</div>
            <div class="qrcode-row">
                <div class="qr-div"><img [src]="QRCode" /></div>
                <div class="qr-description">
                    <div class="description">
                        Scan the QR code using your third-party authentication
                        app or enter the key manually:
                    </div>

                </div>
            </div>
            <div style="font-weight: bold;word-wrap: break-word;">{{QRCodeKey}}</div>
            <div class="input-heading">
                Please enter the code generated by your authentication app to
                verify your identity.
            </div>
            <div class="form-group">
                <input type="text" style="display: none;" name="Mode" value="MFACodeScreen" />
                <mat-form-field name="MFACode" appearance="outline" class="example-full-width mask">
                    <mat-label>Authentication code</mat-label>
                    <input name="MFACode" formControlName="MFACode" autocomplete="off" type="text" matInput />
                    <span class="text-danger"
                        *ngIf="MFAForm.controls['MFACode'].hasError('required') && (MFAForm.controls['MFACode'].dirty || MFAForm.controls['MFACode'].touched)">MFA
                        Code is required</span>
                    <span class="text-danger"
                        *ngIf="MFAForm.controls['MFACode'].hasError('pattern') && (MFAForm.controls['MFACode'].dirty || MFAForm.controls['MFACode'].touched)">MFA
                        Code must be a number</span>
                </mat-form-field>
                <div *ngIf="message" [class]="'text text-' +message.type" role="alert" style="margin-top:-20px">
                    {{message.text}}
                </div>
            </div>
            <div class="checkbox-div">
                <input name="RememberMe30Days" type="checkbox" />
                <div class="checkbox-text">Remember me for {{rememberMeDays}} days</div>
            </div>
            <div class="login-btn">
                <button class="btn btn-primary">Login</button>
            </div>
            <div class="anchor-link">
                <a href="/LoginAngular.aspx?reset">Sign in with a different account</a>
            </div>
        </div>

        <div class="term-of-services">
            <div class="policy-text">
                By clicking on “Login”, you are agreeing to our
                <a href="/Terms.aspx">Terms of service</a> and <br />
                acknowledge that our Privacy policy applies to you
            </div>
            <div class="version-text">
                © {{year}} m-View Live Video Pty Ltd | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>

<div *ngIf="currentScreen === 'MFAScreen'" id="mfa-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay" [formGroup]="MFAForm">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="mfr-title">Multi-factor authentication</div>

            <div class="input-heading">
                Please enter the code generated by your authentication app to
                verify your identity.
            </div>
            <div class="form-group">
                <input type="text" style="display: none;" name="Mode" value="MFAScreen" />
                <mat-form-field name="MFACode" appearance="outline" class="example-full-width mask">
                    <mat-label>Authentication code</mat-label>
                    <input name="MFACode" formControlName="MFACode" autocomplete="off" type="text" matInput />
                    <span class="text-danger"
                        *ngIf="MFAForm.controls['MFACode'].hasError('required') && (MFAForm.controls['MFACode'].dirty || MFAForm.controls['MFACode'].touched)">MFA
                        Code is required</span>
                    <span class="text-danger"
                        *ngIf="MFAForm.controls['MFACode'].hasError('pattern') && (MFAForm.controls['MFACode'].dirty || MFAForm.controls['MFACode'].touched)">MFA
                        Code must be a number</span>
                </mat-form-field>
                <div *ngIf="message" [class]="'text text-' +message.type" role="alert" style="margin-top:-20px">
                    {{message.text}}
                </div>
            </div>
            <div class="checkbox-div">
                <input name="RememberMe30Days" type="checkbox" />
                <div class="checkbox-text">Remember me for {{rememberMeDays}} days</div>
            </div>
            <div class="login-btn">
                <button class="btn btn-primary">Login</button>
            </div>
            <div class="anchor-link">
                <a href="/LoginAngular.aspx?reset">Sign in with a different account</a>
            </div>
        </div>

        <div class="term-of-services">
            <div class="policy-text">
                By clicking on “Login”, you are agreeing to our
                <a href="/Terms.aspx">Terms of service</a> and <br />
                acknowledge that our Privacy policy applies to you
            </div>
            <div class="version-text">
                © {{year}} m-View Live Video Pty Ltd | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>

<div *ngIf="currentScreen === 'AccessDeniedScreen'" id="accessdenied-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="mfr-title">Access Denied</div>

            <div class="input-heading">
                Your account does not appear to be linked to access Portal.<br />
                Please contact your Administrator for further assistance.
            </div>
            <div class="anchor-link">
                <a href="/LoginAngular.aspx?reset">Sign in with a different account</a>
            </div>
        </div>

        <div class="term-of-services">
            <div class="policy-text">
                By clicking on “Login”, you are agreeing to our
                <a href="/Terms.aspx">Terms of service</a> and <br />
                acknowledge that our Privacy policy applies to you
            </div>
            <div class="version-text">
                © {{year}} m-View Live Video Pty Ltd | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>
